import React from "react";
import FontAwesome from "react-fontawesome";
const RederPermitlist = ({
  lastBookElementRef,
  list,
  snackMessage,
  handleOnClick,
  handleChangeToggle,
}) => {
  // console.log(list)
  return (
    <>
      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div className="row" key={item.no}>
                <div ref={lastBookElementRef}  className="container-fluid">
                <div className="card border-secondary mt-1">
                    <div
                      className="card-mb-4 bg-info"
                      style={{ height: "14rm", fontSize: "14px" }}
                    >
                      {item.no}
                    </div>
                    <div className="card-body">
                      <div ref={lastBookElementRef} className="row">
                        <div className="container col-xs-12 col-sm-4">

                        <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"zone:"} {item.zonename}
                          </div>
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ล๊อคที่:"} {item.parkname}
                          </div>
                        
                                       
                               
                         { item.carlicense ? <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ทะเบียนรถ: "}{" "}
                            <span
                              className="badge bg-warning"
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.carlicense}{" "} {item.provincecode}
                            </span>

                            {item.cartypename} 
                            {" สี:"} 
                            {item.colorname}
                          </div>:null}


                        </div>
                        <div className="container col-xs-12 col-sm-4">
                        <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ชื่อ:"} {item.fname} {" "} {item.lname}
                          </div>

                          { item.workstatus==="Resign" ? <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"สถานะ: "}{" "}
                            <span
                              className="badge bg-danger"
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.workstatus}
                            </span>

                     
                          </div>:<div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"สถานะ: "}{" "}
                            <span
                              className="badge bg-success"
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.workstatus}
                            </span>

                     
                          </div>}
                                          

                        </div>
                        <div className="container col-xs-12 col-sm-4">
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ชำระล่าสุด: "}
                            <span
                              className="badge bg-warning"
                              style={{ fontSize: "14px" }}
                            >
                              {" "}
                              {item.payto}{" "}
                            </span>
                          </div>

                        
                      
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="row" key={item.no}>
                <div className="container-fluid">
                  <div className="card border-secondary mt-1">
                    <div
                      className="card-mb-4 bg-info"
                      style={{ height: "14rm", fontSize: "14px" }}
                    >
                      {item.no}
                    </div>
                    <div className="card-body">
                      <div ref={lastBookElementRef} className="row">
                        <div className="container col-xs-12 col-sm-4">

                        <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"zone:"} {item.zonename}
                          </div>
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ล๊อคที่:"} {item.parkname}
                          </div>
                        
                                       
                               
                         { item.carlicense ? <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ทะเบียนรถ: "}{" "}
                            <span
                              className="badge bg-warning"
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.carlicense}{" "} {item.provincecode}
                            </span>

                            {item.cartypename} 
                            {" สี:"} 
                            {item.colorname}
                          </div>:null}


                        </div>
                        <div className="container col-xs-12 col-sm-4">
                        <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ชื่อ:"} {item.fname} {" "} {item.lname}
                          </div>

                          { item.workstatus==="Resign" ? <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"สถานะ: "}{" "}
                            <span
                              className="badge bg-danger"
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.workstatus}
                            </span>

                     
                          </div>:<div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"สถานะ: "}{" "}
                            <span
                              className="badge bg-success"
                              style={{ fontSize: "12px" }}
                            >
                             
                           {" "}  {item.workstatus}
                            </span>

                     
                          </div>}
                                          

                        </div>
                        <div className="container col-xs-12 col-sm-4">
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ชำระล่าสุด: "}
                            <span
                              className="badge bg-warning"
                              style={{ fontSize: "14px" }}
                            >
                              {" "}
                              {item.payto}{" "}
                            </span>
                          </div>

                        
                      
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default RederPermitlist;
